import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { auth } from "@/firebase/firebaseConfig.js";

const pad = (num) => (num < 10 ? `0${num}` : `${num}`);

export const formatTime = (seconds) => ({
  elapsedHours: pad(Math.floor(seconds / 3600)),
  elapsedMinutes: pad(Math.floor((seconds % 3600) / 60)),
  elapsedSeconds: pad(seconds % 60),
});

// Lógica compartida por NavBar (escritorio) y NavBarMobile: timer global y notificaciones.
// El menú de perfil vive en components/Bars/ProfileMenu.vue.
export function useNavBarActions() {
  const store = useStore();

  // ---- Timer ----
  const elapsedTimeOnlySeconds = computed(
    () => store.getters.elapsedTimeOnlySeconds
  );
  const isTimerActive = computed(() => store.getters.isTimerActive);
  const isPaused = computed(() => store.getters.isPaused);
  const selectedTakeaway = computed(() => store.getters.selectedTakeaway);
  const formattedTime = computed(() => {
    const t = formatTime(elapsedTimeOnlySeconds.value);
    return `${t.elapsedHours} : ${t.elapsedMinutes} : ${t.elapsedSeconds}`;
  });

  const showModalStart = ref(false);
  const showModalStop = ref(false);

  const openStartModal = () => {
    showModalStart.value = true;
  };

  const startTimer = async () => {
    await store.dispatch("startTimer", {
      startWithTime: elapsedTimeOnlySeconds.value,
    });
    await store.dispatch("updateElapsedTime");
  };

  const pauseTimer = async () => {
    await store.dispatch("pauseTimer", { fromButton: true });
  };

  const stopTimer = async () => {
    await store.dispatch("pauseTimer", {
      ticket: selectedTakeaway.value?.ticket,
      ...formatTime(elapsedTimeOnlySeconds.value),
      isGlobal: true,
      fromButton: true,
    });
    showModalStop.value = true;
  };

  // ---- Notificaciones ----
  const showNotifications = ref(false);
  const notifications = computed(() => store.getters.notificationsList || []);
  const unreadCount = computed(
    () => notifications.value.filter((n) => !n.is_read).length
  );

  const toggleNotifications = async () => {
    await store.dispatch("fetchNotfications", {
      page: 1,
      limit: 100,
      id_user: auth.currentUser?.uid,
      search: "",
      types: ["action", "info"],
    });
    showNotifications.value = !showNotifications.value;
  };

  onMounted(() => store.dispatch("permissions"));

  return {
    isTimerActive,
    isPaused,
    elapsedTimeOnlySeconds,
    formattedTime,
    showModalStart,
    showModalStop,
    openStartModal,
    startTimer,
    pauseTimer,
    stopTimer,
    showNotifications,
    unreadCount,
    toggleNotifications,
  };
}
